export const precastMergeColumns = [
  {
    displayName: 'Status',
    name: 'sampleStatusType',
    format: '',
  },
  {
    displayName: 'ID / Station Location',
    name: 'sampleId',
    format: 'truncate',
  },
  {
    displayName: 'Collection Date',
    name: 'sampleCollectionDate',
    format: 'date',
  },
  {
    displayName: 'Type',
    name: 'sampleTypeMasterId',
    format: '',
  },
  {
    displayName: 'Mix Design Code',
    name: 'mixDesignCode',
    format: 'truncate',
  },
  {
    displayName: 'Truck #',
    name: 'truckNumber',
    format: '',
  },
  {
    displayName: 'Ticket #',
    name: 'ticketNumber',
    format: '',
  },
  {
    displayName: 'Samples Per Set',
    name: 'numSamplesPerSet',
    format: '',
  },
];
